// src/components/room/MobileMenu.jsx
import React, { useState } from "react";
import useVoiceRoom from "../../hooks/useVoiceRoom";

export default function MobileMenu({
  isConnected,
  uiRoomId,
  unreadCount,
  users,
  currentUsername,
  onChatClick,
  onLeaveRoom,
}) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [copied, setCopied] = useState(false);

  const [openSubMenu, setOpenSubMenu] = useState(null);

  const [isVoiceActive, setIsVoiceActive] = useState(false);

  const voice = useVoiceRoom(
    isVoiceActive ? uiRoomId : null,
    currentUsername
  );

  const closeMenu = () => {
    setIsMenuOpen(false);
    setOpenSubMenu(null);
  };

  const toggleUsers = () => {
    setOpenSubMenu((prev) =>
      prev === "users" ? null : "users"
    );
  };

  const toggleVoice = () => {
    if (isVoiceActive) {
      setIsVoiceActive(false);
      voice.disconnect();
    } else {
      setIsVoiceActive(true);
      voice.connect();
    }
  };

  return (
    <>
      <div className="mobile-header">
        <div className="mobile-room-info">
          <span className="room-label">Room:</span>

          <span
            className="room-code"
            onClick={() => {
              navigator.clipboard.writeText(uiRoomId);
              setCopied(true);

              setTimeout(() => {
                setCopied(false);
              }, 1500);
            }}
            style={{ cursor: "pointer" }}
          >
            {uiRoomId}
          </span>

          {copied && (
            <span className="copy-toast">
              Copied!
            </span>
          )}

          <div
            className={`status-badge ${
              isConnected ? "active" : "inactive"
            }`}
          >
            <span className="status-dot"></span>

            <span className="status-text">
              {isConnected
                ? "Connected"
                : "Connecting"}
            </span>
          </div>
        </div>

        <button
          className="menu-button"
          onClick={() =>
            setIsMenuOpen(!isMenuOpen)
          }
        >
          <span className="menu-icon">☰</span>
        </button>
      </div>

      {isMenuOpen && (
        <>
          <div
            className="menu-overlay"
            onClick={closeMenu}
          />

          <div className="mobile-sidebar">
            <div className="sidebar-header">
              <h3>Menu</h3>

              <button onClick={closeMenu}>
                ✕
              </button>
            </div>

            <div className="sidebar-items">

              <button
                className="sidebar-item"
                onClick={() => {
                  onChatClick();
                  closeMenu();
                }}
              >
                <span className="sidebar-icon">
                  💬
                </span>

                <span>Chat</span>

                {unreadCount > 0 && (
                  <span className="sidebar-badge">
                    {unreadCount}
                  </span>
                )}
              </button>

              <div className="sidebar-item-with-submenu">
                <button
                  className="sidebar-item"
                  onClick={toggleUsers}
                >
                  <span className="sidebar-icon">
                    👥
                  </span>

                  <span>Users</span>

                  {users.length > 0 && (
                    <span className="sidebar-badge">
                      {users.length}
                    </span>
                  )}

                  <span className="submenu-arrow">
                    {openSubMenu === "users"
                      ? "▲"
                      : "▼"}
                  </span>
                </button>

                {openSubMenu === "users" && (
                  <div className="submenu-vertical">
                    <div className="submenu-vertical-content">
                      {users.map((user, idx) => (
                        <div
                          key={idx}
                          className="submenu-user"
                        >
                          <span className="user-avatar">
                            👤
                          </span>

                          <span className="user-name">
                            {user.username}
                          </span>

                          {user.username ===
                            currentUsername && (
                            <span className="user-badge">
                              You
                            </span>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>

              <div className="sidebar-item-with-submenu">
                <button
                  className="sidebar-item"
                  onClick={toggleVoice}
                >
                  <span className="sidebar-icon">
                    🎤
                  </span>

                  <span>Voice</span>

                  <span className="submenu-arrow">
                    {isVoiceActive
                      ? "▲"
                      : "▼"}
                  </span>
                </button>

                {isVoiceActive && (
                  <div className="submenu-vertical">
                    <div className="submenu-vertical-content voice-submenu-content">

                      <div
                        className={`voice-status ${
                          voice.connected
                            ? "connected"
                            : "disconnected"
                        }`}
                      >
                        {voice.connected
                          ? "✅ Connected"
                          : "❌ Disconnected"}
                      </div>

                      {voice.connected && (
                        <button
                          className={`voice-mute-btn ${
                            voice.isMuted
                              ? "muted"
                              : ""
                          }`}
                          onClick={
                            voice.toggleMute
                          }
                        >
                          {voice.isMuted
                            ? "🔇 Unmute"
                            : "🎤 Mute"}
                        </button>
                      )}

                      {voice.participants
                        .length > 0 && (
                        <div className="voice-participants">

                          <div className="voice-participants-title">
                            In voice (
                            {
                              voice.participants
                                .length
                            }
                            )
                          </div>

                          {voice.participants.map(
                            (p) => (
                              <div
                                key={p.id}
                                className="voice-participant"
                              >
                                <span className="voice-participant-icon">
                                  {p.isSpeaking
                                    ? "🔊"
                                    : p.local
                                      ? voice.isMuted
                                        ? "🔇"
                                        : "🔈"
                                      : "🔈"}
                                </span>

                                <span className="voice-participant-name">
                                  {p.name}{" "}
                                  {p.local &&
                                    "(You)"}
                                </span>
                              </div>
                            )
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>

              <button
                className="sidebar-item sidebar-item-danger"
                onClick={() => {
                  voice.disconnect();
                  onLeaveRoom();
                  closeMenu();
                }}
              >
                <span className="sidebar-icon">
                  🚪
                </span>

                <span>Leave Room</span>
              </button>

            </div>
          </div>
        </>
      )}
    </>
  );
}
